import { isTransparent } from '@wix/shoutout-email-model-v3';
import { defaultBackgroundColor } from '../defaults';
import { toRgbAsHex } from '../color';
import { extractTextStyles } from './extract-text-styles';
export function calcBackgroundColor(color) {
    if (isTransparent(color)) {
        return 'transparent';
    }
    return toRgbAsHex(color);
}
export const getSecondaryButton = (globalStyles, localStyles, text, href) => {
    const fallbackButtonStyles = globalStyles['so-global-b2'];
    const buttonBorderWidth = localStyles.borderWidth || fallbackButtonStyles.borderWidth || '0px';
    const buttonBorderColor = localStyles.borderColor || fallbackButtonStyles.borderColor || '#000';
    return {
        ...extractTextStyles(localStyles, fallbackButtonStyles),
        backgroundColor: calcBackgroundColor(localStyles.background ||
            fallbackButtonStyles.backgroundColor ||
            defaultBackgroundColor),
        border: `solid ${buttonBorderWidth} ${buttonBorderColor}`,
        borderRadius: fallbackButtonStyles.borderRadius || 'Opx',
        href,
        text,
    };
};
//# sourceMappingURL=get-secondary-button.js.map